import React, { Component } from "react";

class InterfaceProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      properties: [],
    };

    if (this.props.hide === true) {
      this.state.properties.push(
        {
          property: "hide",
          description: "Hides component from the interface.",
          defaults: "true, false default is false",
        },
        {
          property: "hide_if_eval",
          description:
            "Hides the component in the interface using a eval logic for more information look up component eval in this documentation.",
          defaults: "(NL.Record.data.text_name !== 'John Smith')",
        }
      );
    }

    if (this.props.onClick === true) {
      this.state.properties.push(
        {
          property: "on_click_eval",
          description:
            "onClick event when clicking on the component.",
          defaults: '"NL.Interface.navigateTo(\'record/ contact / CON - \' + NL.Record.data.object_contact.text_id)"',
        }
      );
    }

    if (this.props.order === true) {
      this.state.properties.push({
        property: "order",
        description:
          "The layout order that component will be displayed within the container.",
        defaults: "1-10000",
      });
    }

    if (this.props.padding === true) {
      this.state.properties.push(
        {
          property: "padding",
          description:
            "Adds the horizontal 8px padding on each side of the component.",
          defaults: "true, false default true",
        },
        {
          property: "padding_bottom",
          description:
            "Adds the vertical 16px padding on the bottom of the component.",
          defaults: "true, false default true",
        },
        {
          property: "padding_top",
          description:
            "Adds the vertical 16px padding on the top of the component.",
          defaults: "true, false default false",
        }
      );
    }

    if (this.props.tabIndex === true) {
      this.state.properties.push({
        property: "tab_index",
        description: "Interface html tab-index used for tab keyboard shortcut.",
        defaults: "1-10000",
      });
    }

    if (this.props.button === true) {
      this.state.properties.push(
        {
          property: "button_color",
          description: "The color of the button.",
          defaults: '"#F44336" default is "#1E88E5"',
        },
        {
          property: "button_font_color",
          description: "The color of the text in the button.",
          defaults: '"#212121" default is "#FFFFFF"',
        },
        {
          property: "button_position",
          description:
            "The postion in the column the button will be displayed.",
          defaults: '"left", "center", "right" default is "left"',
        },
        {
          property: "button_raised",
          description: "Button displayed as raised or flat.",
          defaults: "true, false default is true",
        },
        {
          property: "button_width",
          description:
            'The width of the button in pixels. button_width also supports "full" and "auto".',
          defaults: '220 default is "auto"',
        }
      );
    }

    if (this.props.readOnly === true) {
      this.state.properties.push(
        {
          property: "read_only",
          description:
            "Changes the control to read only stopping the user from entering data.",
          defaults: "true, false default false",
        },
        {
          property: "read_only_eval",
          description:
            "Changes the control to be read only when a boolean condition is met.",
          defaults: "(NL.Record.data.text_name !== 'John Smith')",
        }
      );
    }

    if (this.props.displayName === true) {
      this.state.properties.push({
        property: "display_name",
        description: "Display name shown over component in the interface.",
        defaults: '"My field name"',
      });
    }

    if (this.props.onChangeEval === true) {
      this.state.properties.push({
        property: "on_change_eval",
        description:
          "Allows you to insert javascript code at the client level when this data is edited.",
        defaults:
          "\"console.log('NL and event in console.', { NL: NL, event: event })\"",
      });
    }

    if (this.props.searchGroup === true) {
      this.state.properties.push({
        property: "search_group",
        warning: true,
        description:
          "The search_group property is required to link the filter to the search results component.",
        defaults: '"my_search_group"',
      });
    }

    if (this.props.sourceUrl === true) {
      this.state.properties.push(
        {
          property: "source_url_api",
          description: "source data type component links to.",
          defaults: '"data_type"',
        },
        {
          property: "source_url_api_system_object",
          description: 'Is the source data type a system object like "user".',
          defaults: "true, false default is false",
        },
        {
          property: "source_sort",
          description:
            "Sort the records returned by the database select record function.",
          defaults: "{ ... }",
        },
        {
          property: "source_query",
          description:
            "Gives you the ability to write a query on the database select record function.",
          defaults: "{ ... }",
        },
        {
          property: "source_size",
          description:
            "Limits the number of options retrieved from the database.",
          defaults: "1-10000 default is 100",
        }
      );
    }

    if (this.props.sourceDebug === true) {
      this.state.properties.push({
        property: "source_debug",
        description:
          "Source debug is a setting to help you develop and debug complex reports. We do not recommend this setting should be used in live production systems. When the source debug is turned on, the report component will output the report data at each stage into the web browser development console (typically F12 to view). ",
        defaults: "true, false default is false",
      });
    }

    if (this.props.sourceAggs === true) {
      this.state.properties.push(
        {
          property: "source_aggs",
          description:
            "Aggregate searches are ElasticsSearch's equivalent of SQL's group by function. An Aggregate search can sum, count, average groups within a dataset. For more information, please review the Aggregate search documentation on the ElasticsSearch website.",
          defaults: "{ ... }",
        },
        {
          property: "source_aggs_convert",
          description:
            "Aggregate searches by default return the result as a single record. By default, we convert the aggregated result buckets into separate records. This feature can be turned ed off by setting the source aggs convert to false.",
          defaults: "true, false default is true",
        }
      );
    }

    if (this.props.sourceSave === true) {
      this.state.properties.push({
        property: "source_save",
        description: "Fields saved in the database.",
        defaults: '["text_my_field_1", "text_my_field_2"]',
      });
    }

    if (this.props.sourceJoin === true) {
      this.state.properties.push({
        property: "source_join",
        description:
          "Source join allows you to look up and join other data types to your record. Source join allows for multiple joins.  There are three components to a source join. The secondary data source made up of the API URL and whether it's a system object — the primary ID which is the ID of the secondary dataset record — and finally, the output or data you want from the secondary record.",
        description2: "source_url_api: The secondary api source.",
        description3:
          "source_url_api_system_object: Set if the secondary api source is a system object.",
        description4:
          "source_primary_id: The feild in the prmary record which contains the secondary ID.",
        description5:
          "source_output: The feilds you want collected from the secondary record.",
        defaults: "{ ... }",
      });
    }

    if (this.props.displaySort === true) {
      this.state.properties.push(
        {
          property: "display_sort",
          description:
            "Set the default display sort by field. This is different from the source_sort property in that display_sort happens after all joins and data manipulations where source_sort occurs at the database level and can only be applied to numbers and dates.",
          defaults: '"record.text_my_field_2" default is undefined',
        },
        {
          property: "display_sort_up",
          description:
            "By default, display_sort sorts data in ascending order. To invert this set display_sort_up to true.",
          defaults: "true, false default is false",
        }
      );
    }

    if (typeof this.props.autoFill === "string") {
      this.state.properties.push({
        property: "auto_fill",
        description: "Autofill component with value if empty.",
        defaults: this.props.autoFill,
      });
    }

    if (typeof this.props.dataNameDefault === "string") {
      this.state.properties.push({
        property: "data_name",
        warning: true,
        description: "Field in the database bound to this component.",
        defaults: this.props.dataNameDefault,
      });
    }

    if (Array.isArray(this.props.properties)) {
      for (var i = 0; i < this.props.properties.length; i++) {
        this.state.properties.push(this.props.properties[i]);
      }
    }

    this.state.properties.sort(function (a, b) {
      return b.property > a.property ? -1 : b.property < a.property ? 1 : 0;
    });
  }

  render() {
    return (
      <div>
        <h3>Properties</h3>
        <table>
          <tbody>
            <tr>
              <td className="b top">Property</td>
              <td className="b top">Description</td>
            </tr>
            {typeof this.props.name === "string" &&
              typeof this.props.type === "string" ? (
              <tr>
                <td className="b">type</td>
                <td>
                  <i
                    className="material-icons"
                    style={{
                      display: "inline-block",
                      height: 24,
                      position: "relative",
                      top: 6,
                      paddingRight: 8,
                      fontSize: 24,
                      color: "#F57C00",
                    }}
                  >
                    warning
                  </i>
                  Must be <strong>"{this.props.type}"</strong> for the{" "}
                  {this.props.name} component.
                  <br />
                  <i>
                    <strong>"{this.props.type}"</strong>
                  </i>
                </td>
              </tr>
            ) : null}

            {this.state.properties.map((item, index) => (
              <tr key={item.property}>
                <td className="b">{item.property}</td>
                <td>
                  {item.warning === true ? (
                    <i
                      className="material-icons"
                      style={{
                        display: "inline-block",
                        height: 24,
                        position: "relative",
                        top: 6,
                        fontSize: 24,
                        paddingRight: 8,
                        color: "#F57C00",
                      }}
                    >
                      warning
                    </i>
                  ) : null}
                  <span>{item.description}</span>

                  {typeof item.description2 === "string" ? (
                    <span>
                      <br />
                      <br />
                      {item.description2}
                    </span>
                  ) : null}
                  {typeof item.description3 === "string" ? (
                    <span>
                      <br />
                      <br />
                      {item.description3}
                    </span>
                  ) : null}
                  {typeof item.description4 === "string" ? (
                    <span>
                      <br />
                      <br />
                      {item.description4}
                    </span>
                  ) : null}
                  {typeof item.description5 === "string" ? (
                    <span>
                      <br />
                      <br />
                      {item.description4}
                    </span>
                  ) : null}
                  <br />
                  <i>{item.defaults}</i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default InterfaceProperties;



// WEBPACK FOOTER //
// ./src/components/Interface/InterfaceProperties.js